import React, { Component } from 'react';
import './Notes.scss';
import Button from '../Button';
import Icon from '../Icon';
import NoteForm from '../NoteForm';
import Overlay from '../Overlay';
import Search from '../Search';
import Actions from '../Actions';
import NotesRepeater from './NotesRepeater';
import Empty from '../Empty';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setFndFormData, clearFndFormData } from '../../store/actions/fndForm';
import { selectSearch } from '../../store/selectors/search';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { getUrlExtension } from '../../helpers/CommonHelpers';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';

class Notes extends Component {
  state = {
    showOverlay: false,
    isOpen: false,
    note: {},
  };

  onImageClick(x, data) {
    if (getUrlExtension(data.image) === 'heic') {
      window.open(data.image);
    } else {
      this.setState({
        isOpen: true,
        note: data,
      });
    }
  }

  render() {
    const {
      notes,
      onSaveNote,
      onDeleteNote,
      breadcrumb,
      onSearch,
      setFndFormData,
      clearFndFormData,
      search,
      from,
      user,
    } = this.props;
    const { showOverlay, isOpen, note } = this.state;

    return (
      <div className="notes">
        <Actions compact>
          <Search
            size="small"
            placeholder="Search Notes..."
            onChange={onSearch}
          />
          {this.props.user.roles[0].role.name === 'Strata Manager' ||
          user.roles[0].role.name === 'Vendor' ||
          this.props.user.roles[0].role.name === 'Home Owner' ||
          this.props.user.roles[0].role.name === 'Realtor' ||
          this.props.user.roles[0].role.name === 'Occupant' ? null : (
            <Button
              color="teal"
              label="Add Note"
              onClick={() => this.setState({ showOverlay: true })}
              icon={<Icon glyph="edit" weight="light" size="small" />}
              size="small"
            />
          )}
        </Actions>
        {notes.length > 0 ? (
          <>
            <NotesRepeater
              user={user}
              notes={notes}
              onEdit={(note) => {
                if (note.appointment) {
                  let date = new Date(note.appointment.date);
                  let time =
                    note.appointment && note.appointment.time
                      ? new Date(note.appointment.time)
                      : null;
                  let appointment = {
                    date,
                    time,
                  };
                  note = { ...note, appointment };
                }

                setFndFormData(note);
                this.setState({ showOverlay: true });
              }}
              onDelete={(note) =>
                window.confirm(
                  `Are you sure you want to delete ${note.title}?`
                ) && onDeleteNote(note)
              }
              onImageClicked={(x, data) => {
                this.onImageClick(x, data);
              }}
            />
            {isOpen && isOpen === true ? (
              <ReusableLightbox
                isOpen={isOpen}
                onClose={() => this.setState({ isOpen: false })}
                image={note.image}
              />
            ) : null}
          </>
        ) : (
          <Empty
            headline="No notes yet"
            strapline="You can use the Notes section to post any status updates or general comments to keep everyone on the same page."
            searchIsActive={search && search.notes ? search.notes : ''}
            cta={
              this.props.user.roles[0].role.name === 'Strata Manager' ||
              this.props.user.roles[0].role.name === 'Home Owner' ||
              this.props.user.roles[0].role.name === 'Realtor' ||
              this.props.user.roles[0].role.name === 'Occupant' ? null : (
                <Button
                  color="teal"
                  label="Add Note"
                  onClick={() => this.setState({ showOverlay: true })}
                  icon={<Icon glyph="edit" weight="light" size="small" />}
                  size="small"
                />
              )
            }
            image={<img alt="No notes yet" src="/assets/empty/notes.svg" />}
          />
        )}
        <Overlay
          showOverlay={showOverlay}
          content={
            <NoteForm
              from={from}
              breadcrumb={breadcrumb}
              onSaveNote={onSaveNote}
              onClose={() =>
                this.setState({ showOverlay: false }, () => clearFndFormData())
              }
            />
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: selectAuthenticatedUser(state),
  search: selectSearch(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setFndFormData,
      clearFndFormData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Notes);
